import styled from "@emotion/styled"
import { LikeTeamAction } from "@pallet/features/RecruitingTeamType/LikeTeamAction"
import { useTeamProfileModal } from "@pallet/features/RecruitingTeamType/TeamProfileModal/hooks"
import { Box, textStyles, theme } from "@pallet-hq/hegel"
import UnstyledButton from "components/Buttons/UnstyledButton"
import { MiniTeamProfileActionRowFragment } from "__generated__/MiniTeamProfileActionRowFragment"

type ActionRowProps = {
    team: MiniTeamProfileActionRowFragment
}

const ActionRow = ({ team }: ActionRowProps) => {
    const { showModal } = useTeamProfileModal()
    return (
        <Box
            display="flex"
            p="12px"
            gridGap="xsmall"
            width="100%"
            justifyContent="center"
            backgroundColor="gray200"
            borderBottomLeftRadius="12px"
            borderBottomRightRadius="12px"
            style={{ boxSizing: "border-box" }}
        >
            <ViewButton
                onClick={() => showModal(team.uuid)}
                style={{ minWidth: "fit-content" }}
            >
                View profile
            </ViewButton>
            <LikeTeamAction team={team} />
        </Box>
    )
}

export { ActionRow }

const ViewButton = styled(UnstyledButton)`
    ${textStyles.uiSmall500};
    margin-left: auto;
    padding: 9px 6px;
    border-radius: 6px;
    color: ${theme.colors.gray600};
    &:hover {
        background-color: ${theme.colors.gray300};
    }
`
